import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {ViewByIdDefaultPagePage} from './view-by-id-default-page.page';
import {DefaultAppPageModule} from "../../../../components/common/defaut-application-page/default-app-page.module";
import {ViewByIdDefaultModule} from "../../component/view-by-id-default/view-by-id-default.module";
import {LoadingModule} from "../../../../components/common/loading/loading.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        DefaultAppPageModule,
        LoadingModule,
        ViewByIdDefaultModule,
    ],
    declarations: [ViewByIdDefaultPagePage],
    exports: [ViewByIdDefaultPagePage]
})
export class ViewByIdDefaultPagePageModule {
}
